import {
	type CreateErrorHandler,
	createErrorHandlerWithPackageContext,
	logErrorMessageWithPackageContext,
	logExceptionWithPackageContext,
	logInfoMessageWithPackageContext,
} from '@atlaskit/teams-client/sentry';

const packageContext = {
	packageName: process.env._PACKAGE_NAME_ as string,
	packageVersion: process.env._PACKAGE_VERSION_ as string,
};

export { useTeamsSentryClientSetup as useSentryClient } from '@atlaskit/teams-client/sentry';

export const logException: (ex: unknown, name: string, context?: any) => void =
	logExceptionWithPackageContext(packageContext);
export const logErrorMessage: (message: string, context?: any) => void =
	logErrorMessageWithPackageContext(packageContext);
export const logInfoMessage: (message: string, context?: any) => void =
	logInfoMessageWithPackageContext(packageContext);
export const createErrorHandler: CreateErrorHandler =
	createErrorHandlerWithPackageContext(packageContext);
